export default __webpack_public_path__ + "static/media/bootstrap-logo.cfff4fa2.svg";